import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import HomeHeader from '../../components/homeHeader/index.vue'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {}
  },
  components: {
    HomeHeader
  },
  async mounted () {
    if (localStorage.getItem('access-token')) {
      this.$router.push('/dashboard')
    }
  }
}
